import {Component} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {LoaderService} from "../../../services/loader/loader.service";
import {TokenStorageService} from "../../../services/token-storage.service";
import {Observable} from "rxjs";
import {RestResponse} from "../../../Interfaces/RestResponse.interface";
import RestHelper from "../../../Helper/RestHelper";
import {User} from "../../../Interfaces/user.interface";
import PermissionsHelper from "../../../Helper/PermissionsHelper";
import Helper from "../../../Helper/Helper";
import {Router} from "@angular/router";

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html'
})
export class UserComponent {

  constructor(private httpClient: HttpClient, protected loader: LoaderService, public tokenStorage: TokenStorageService, public router: Router) {
    this.loader.showLoader()
    this.users = this.getUsers()
  }

  public tableheader = [
    {
      display_name: "UUID",
      sort_name: "uuid"
    },
    {
      display_name: "Benutzername",
      sort_name: "username"
    },
    {
      display_name: "Vorname",
      sort_name: "name"
    },
    {
      display_name: "Nachname",
      sort_name: "lastname"
    },
    {
      display_name: "Kunde",
      sort_name: "customer"
    },
    {
      display_name: "Verifiziert",
      sort_name: "verified"
    },
    {
      display_name: "Deaktiviert",
      sort_name: "disabled"
    },
    {
      display_name: "Letzer Login",
      sort_name: "lastlogin"
    },
    {
      display_name: "Erstellungsdatum",
      sort_name: "creation_date"
    },
    {
      display_name: "Berechtigungen",
      sort_name: "permissions"
    }
  ]

  public users: Observable<User[]> | undefined
  public apierror: boolean = true


  private getUsers(sortby: string = "", sorttype: string = ""): Observable<User[]> {

    const urlSearchParams = new URLSearchParams();

    if (sortby !== "") {
      urlSearchParams.set("sortby", sortby);
    }
    if (sorttype !== "") {
      urlSearchParams.set("sorttype", sorttype);
    }

    return new Observable(subscriber => {

      this.httpClient.get<RestResponse<User[]>>(RestHelper.API_BASE_URL + "user/getUserList?admin=true&" + urlSearchParams.toString(), RestHelper.requestOptions).subscribe({
        next: (value) => {
          subscriber.next(value.data)
          this.loader.hideLoader()
        }, error: () => {
          this.apierror = true
          this.loader.hideLoader()
        }
      })
    })
  }

  public changeStatus(event: Event, uuid: string, key: string) {

    event.preventDefault()
    event.stopPropagation();

    const input = event.target as HTMLInputElement;
    const body = new FormData();

    body.append("uuid", uuid)
    body.append(key, String(input.checked))

    this.httpClient.patch(RestHelper.API_BASE_URL + 'user/updateUser', body, RestHelper.requestOptions)
      .subscribe({
        next: () => {
          input.checked = !input.checked
        },
        error: (err) => {
          console.error(err)
        }
      });
  }

  public getPermissionList(permissions: Array<String>): string {
    if (permissions.length <= 1) {
      return permissions.toString()
    }

    let htmllist: string = "<ul class='list-unstyled'>"

    for (let permission of permissions) {
      htmllist = htmllist.concat("<li>- " + permission + "</li>")
    }
    htmllist = htmllist.concat("</ul>")

    return htmllist
  }

  public lastsort: string = ""
  public lastsorttype = ""

  public sortTablebyColum(property: string) {
    let sorttype: string;
    if (this.lastsort === property) {
      if (this.lastsorttype === "ASC") {
        sorttype = "DESC";
      } else {
        sorttype = "ASC"
      }
    } else {
      sorttype = "ASC"
    }
    this.lastsort = property
    this.lastsorttype = sorttype;
    this.users = this.getUsers(property, sorttype)
  }

  protected readonly Helper = Helper;
  protected readonly PermissionsHelper = PermissionsHelper;
}
